import { render, staticRenderFns } from "./LoadingShow.vue?vue&type=template&id=51bf8c6e&scoped=true"
import script from "./LoadingShow.vue?vue&type=script&lang=js"
export * from "./LoadingShow.vue?vue&type=script&lang=js"
import style0 from "./LoadingShow.vue?vue&type=style&index=0&id=51bf8c6e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bf8c6e",
  null
  
)

export default component.exports